<template>
  <div>
    <template v-if="inForm">
      <BaseForm :barcode="barcode" @close="inForm = false" />
    </template>
    <div v-else-if="openForms.enable">
      <ListForms @close="openForms.enable=false" :name="openForms.name" :barcode_id="openForms.barcode_id" />
    </div>
    <template v-else>
      <div>
        <div class="tasks-title-box w-100 rounded my-5 text-center">
          <v-col class="my-auto mx-auto mobile-d-none">
            <h3>بارکد خوان</h3>
          </v-col>
        </div>

        <div class="last-changes rounded-lg container w-100">
          <div v-if="!isScanning && !openForms.enable" class="w-100 text-center">
            <v-icon
                style="font-size: 20em; cursor: pointer;"
                color="primary"
                @click="isScanning = true"
            >
              mdi-camera
            </v-icon>
            <small>برای اسکن کلیک کنید</small>
          </div>

          <div v-else-if="isScanning" class="text-center">
            <qrcode-stream
                :camera="camera"
                style="max-width: 700px; height: auto;"
                @init="onInit"
                @decode="onDecode"
                class="container"
            >
              <v-btn color="primary" @click="toggleCamera">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-camera-switch</v-icon>
                  </template>
                  <span>تغییر دوربین</span>
                </v-tooltip>
              </v-btn>
            </qrcode-stream>
            <p>لطفا بارکد را در محل اسکن قرار دهید</p>
          </div>

          <v-data-table
              dense
              v-else
              hide-default-footer
              :headers="barcodes.headers"
              :items="[barcode]"
              loading-text="در حال دریافت اطلاعات..."
              no-data-text="اطلاعاتی یافت نشد."
              class="elevation-0"
          >
            <template v-slot:item.img="{ item }">
              <v-img :src="item.img" width="145px" height="145px" class="mx-auto my-3 barcode" />
            </template>

            <template v-slot:item.description="{ item }">
              <p>{{ item.device_name }}</p>
            </template>

            <template v-slot:item.created_at="{ item }">
              <v-tooltip top color="red">
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on">
                    {{ formatDate(item.created_at) }}
                  </a>
                </template>
                <span>{{ formatTime(item.created_at) }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.download="{ item }">
              <v-btn color="success" outlined x-large @click="openForm">
                کامل کردن گزارش
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { QrcodeStream } from "vue-qrcode-reader";
import BaseForm from "@/components/forms/base-form.vue";
import ListForms from "@/components/forms/list.vue";

export default {
  name: "HomeBarcodeRead",
  components: {
    ListForms,
    QrcodeStream,
    BaseForm,
  },
  data: () => ({
    key: localStorage.getItem("key"),
    inForm: false,
    openForms: { name: "", enable: false },
    isScanning: false,
    camera: "rear",
    barcode: {},
    barcodes: {
      headers: [
        { text: "نام", align: "center", value: "name" },
        { text: "شرح", sortable: false, align: "center", value: "description" },
        { text: "زمان ثبت", align: "center", value: "created_at" },
        { text: "بارکد", align: "center", value: "img" },
        { text: "دریافت", sortable: false, align: "center", value: "download" },
      ],
    },
  }),
  methods: {
    async onDecode(decodedString) {
      this.$snotify.success("در حال دریافت اطلاعات...");
      try {
        const response = await axios.get(`${this.BACKEND_LINK}/api/barcode/${decodedString}/`, {
          headers: { Authorization: `Token ${this.key}` },
        });
        this.barcode = response.data;
        this.openForms.barcode_id = this.barcode.id;
        if(parseInt(this.$GLOBAL_DATA.user['degree']) >= 3) {
            this.openForms.name = this.barcode.name
            this.openForms.enable = true
        }else {
          this.openForm();
        }
      } catch (error) {
        this.$snotify.error("خطا در دریافت بارکد.");
      } finally {
        this.isScanning = false;
      }
    },
    async onInit(promise) {
      this.$snotify.warning("لطفا اجازه دسترسی به دوربین را صادر کنید...", "دسترسی به دوربین");
      try {
        await promise;
      } catch (error) {
        this.handleCameraError(error);
      }
    },
    handleCameraError(error) {
      const errorMessages = {
        NotAllowedError: "اجازه دسترسی به دوربین صادر نشد!",
        NotFoundError: "دوربین پیدا نشد!",
        NotSupportedError: "سایت در حالت امن یا (HTTPS) راه اندازی نشده!",
        NotReadableError: "این دوربین استفاده شده!",
      };
      this.$snotify.error(errorMessages[error.name] || "خطای ناشناخته", "خطا");
    },
    toggleCamera() {
      this.camera = this.camera === "front" ? "rear" : "front";
    },
    formatDate(dateString) {
      return new Date(dateString.split("T")[0]).toLocaleDateString("fa-IR");
    },
    formatTime(dateString) {
      return dateString.split("T")[1].split(".")[0];
    },
    openForm() {
      this.inForm = true;
    },
    closeForm() {
      this.openForms = { name: "", enable: false };
    },
  },
};
</script>
